const ACTION_PREPEND = 'orderPlaced';
export const ORDER_PLACED_LOADED = `${ACTION_PREPEND}/ORDER_PLACED_LOADED`;
export const SET_ORDER_PLACED_DASHBOARD_TOAST = `${ACTION_PREPEND}/SET_ORDER_PLACED_DASHBOARD_TOAST`;
export const RESET_ORDER_PLACED_TOAST = `${ACTION_PREPEND}/RESET_ORDER_PLACED_TOAST`;
export const TOGGLE_ORDER_SUMMARY = `${ACTION_PREPEND}/TOGGLE_ORDER_SUMMARY`;
export const GET_VEHICLE_SOLD_ON_LOT = `${ACTION_PREPEND}/GET_VEHICLE_SOLD_ON_LOT`;
export const DETERMINE_NRSF = `${ACTION_PREPEND}/DETERMINE_NRSF`;
export const DETERMINE_CONTRACT_TO_CR = `${ACTION_PREPEND}/DETERMINE_CONTRACT_TO_CR`;
export const DETERMINE_CONTRACT_TO_CR_PHASE_2 = `${ACTION_PREPEND}/DETERMINE_CONTRACT_TO_CR_PHASE_2`;
export const GET_PAYMENT_SUMMARY = `${ACTION_PREPEND}/GET_PAYMENT_SUMMARY`;

// These actions get picked up by customer-request/ducks/reducer
export const SELECTED_CUSTOMER_REQUEST = `customerRequest/SELECTED_CUSTOMER_REQUEST`;

// These actions get picked up by purchase-ui/src/component/dashboard/ducks/reducer
export const ORDER_SUMMARY_FETCH = 'purchase/ORDER_SUMMARY_FETCH';
export const GET_DASHBOARD = `GET_DASHBOARD`;

// These actions get picked up by purchase-ui/src/component/app/ducks/reducer
export const GET_USER_EXPERIMENTS = `purchase/GET_USER_EXPERIMENTS`;
